import ScrapExecutionDetail from '@/models/ScrapExecution/ScrapExecutionDetail';

export default class ScrapExecutionDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.scrapExecutionId  = '';
		this.scrapExecutionScrapExecutionNumber = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.partName = '';
		this.caseQty = '';
		this.isScrap = false;
		this.fileEvidenceId  = '';
		this.fileEvidenceOriginalFilename = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			scrapExecutionId : '0',
			scrapExecutionScrapExecutionNumber : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			partId : '0',
			partPartNumber : '0',
			partName : '0',
			caseQty : '0',
			isScrap : '0',
			fileEvidenceId : '0',
			fileEvidenceOriginalFilename : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}